import Styles from '../MetaAdsAccountSetupModal.module.scss'
import { CheckBroken } from 'blaze-ui/icons'

export const SuccessTag = ({ text }: { text: string }) => {
  return (
    <div className={Styles.connectedTag}>
      <span className={Styles.text}>{text}</span>
      <CheckBroken size={20} className={Styles.checkIcon} />
    </div>
  )
}
